import * as React from "react"
const ThumbtackThinActive = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 18 }
        height={ 18 }
        fill="currentColor"
        viewBox="0 0 24 24"
        { ...props }
    >
        <path d="M21.706 9.801 20.707 8.8l-6.492-6.504-.006-.006a.998.998 0 0 0-1.413.006l-.006.006a1.002 1.002 0 0 0 .006 1.415l.3.29L8.651 8.41a9.97 9.97 0 0 0-4.994.66 1.001 1.001 0 0 0-.639.72 1 1 0 0 0 .29.911l4.243 4.25-4.051 4.05-1 2.499 2.5-1 4.049-4.048 4.247 4.255a.996.996 0 0 0 .929.26 1 1 0 0 0 .719-.64c.643-1.584.87-3.306.659-5.003l4.395-4.403.29.3a1.004 1.004 0 0 0 1.418-1.42zm-7.941 4.473a1.002 1.002 0 0 0-.25 1.001 5.736 5.736 0 0 1 0 2.822l-7.61-7.626a5.716 5.716 0 0 1 2.817 0 .998.998 0 0 0 .999-.25l4.784-4.803 4.055 4.063-4.795 4.793z" />
    </svg>
)
export default ThumbtackThinActive;
